import { useState, useCallback, useRef } from 'react';

/**
 * Custom hook to manage filter bar UI state separately from data fetching
 * This prevents the filter bar from re-rendering when data changes
 */
export function useFilterBarState() {
  // Filter bar visibility state
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  
  // Property search state
  const [propertySearch, setPropertySearch] = useState('');
  const [showPropertyDropdown, setShowPropertyDropdown] = useState(false);
  
  // Area interaction tracking
  const [hasUserInteractedWithAreas, setHasUserInteractedWithAreas] = useState(false);
  
  // Stable references to prevent unnecessary re-renders
  const stableSetIsFiltersOpen = useCallback((value) => {
    setIsFiltersOpen(value);
  }, []);
  
  const stableSetPropertySearch = useCallback((value) => {
    setPropertySearch(value);
  }, []);
  
  const stableSetShowPropertyDropdown = useCallback((value) => {
    setShowPropertyDropdown(value);
  }, []);
  
  const stableSetHasUserInteractedWithAreas = useCallback((value) => {
    setHasUserInteractedWithAreas(value);
  }, []);
  
  return {
    // State values
    isFiltersOpen,
    propertySearch,
    showPropertyDropdown,
    hasUserInteractedWithAreas,
    
    // Stable setters
    setIsFiltersOpen: stableSetIsFiltersOpen,
    setPropertySearch: stableSetPropertySearch,
    setShowPropertyDropdown: stableSetShowPropertyDropdown,
    setHasUserInteractedWithAreas: stableSetHasUserInteractedWithAreas
  };
} 